import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {CreditCardResponse} from "../models/creditCardResponse";
import {Observable} from "rxjs";
import {InitPaymentRequest} from "../models/payment/initPaymentRequest";
import {InitPaymentResponse} from "../models/payment/initPaymentResponse";

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {

  private endpointUrl = `${environment.apiUrl}/credit-cards`;

  constructor(private http: HttpClient) {
  }

  public addNewCreditCard(initPaymentRequest: InitPaymentRequest) {
    const url = `${this.endpointUrl}`;
    return this.http.post<InitPaymentResponse>(url, initPaymentRequest);
  }

  public getAll(): Observable<Array<CreditCardResponse>> {
    const url = `${this.endpointUrl}/all`;
    return this.http.get<Array<CreditCardResponse>>(url);
  }

  public getActive(): Observable<CreditCardResponse> {
    const url = `${this.endpointUrl}/active`;
    return this.http.get<CreditCardResponse>(url);
  }

  public updateActivity(id: bigint, active: boolean): Observable<void> {
    const url = `${this.endpointUrl}/activity`;
    const params = `?id=${id}&active=${active}`;
    const urlWithParams = url + params;
    return this.http.patch<void>(urlWithParams, null);
  }

  public deleteById(id: bigint): Observable<void> {
    const url = `${this.endpointUrl}/${id}`;
    return this.http.delete<void>(url);
  }

  public deleteByCardHolderId(cardHolderId: string): Observable<void> {
    const url = `${this.endpointUrl}/cardHolderId/${cardHolderId}`;
    return this.http.delete<void>(url);
  }
}
